<template>
   <van-popup v-model:show="show" @click-overlay="() => playClickSound()" position="left"
      :style="{ height: '100%', width: '74%', zIndex: '10002', paddingBottom: '48px' }">

      <van-row class="navBar" justify="space-between">
         <van-col span="4" @click="closeSidebar" class="navBar_menu">
            <img src="@/assets/themetwo/back.png" alt="">
         </van-col>
         <van-col span="20" class="navBar_logo">
            <img src="@/assets/themetwo/f2.png" alt="">
         </van-col>
         <van-col span="24" class="navNotice">
            <img src="@/assets/themetwo/b4.png" alt="">
         </van-col>
      </van-row>
      <div class="infoContainer">
         <van-row v-if="userStore.loginAccount" class="user_info">
            <van-col span="6" @click="closeSidebar" class="user_avatar">
               <img src="@/assets/themetwo/headsculpture_img_0.png" alt="">
            </van-col>
            <van-col span="18" class="user_text">
               <div class="user_account">{{ userAccount }}</div>
               <div class="user_ID">
                  {{ $t('profile.id') }}：{{ uId }}
                  <img src="@/assets/themetwo/icon-copy.png" alt="" @click="onCopyID(uId)">
               </div>
            </van-col>
         </van-row>
         <van-row v-if="!userStore.loginAccount" class="user_info">
            <van-col span="12" class="btn_col">
               <div class="loginButton" @click="openRegisterPopup(1)">{{ $t('common.login') }}</div>
            </van-col>
            <van-col span="12" class="btn_col">
               <div class="registerButton" @click="openRegisterPopup(0)">{{ $t('common.register') }}</div>
            </van-col>
         </van-row>
         <van-row v-else class="button_group">
            <van-col span="12" class="btn_grid">
               <PrimaryButton :icon="require('@/assets/themetwo/pig.png')" :text="$t('common.deposite')"
                  textColor="#FFFFFF" bgColor="#ff69b4" @onClick="buttonClick('topup')" />
            </van-col>
            <van-col span="12" class="btn_grid">
               <PrimaryButton :icon="require('@/assets/themetwo/wallet.png')" :text="$t('common.sake')"
                  textColor="#9b5b00" bgColor="#ffd60c" @onClick="buttonClick('withdraw')" />
            </van-col>
         </van-row>
      </div>
      <div class="menu_list">
         <van-row class="menu_row" justify="space-between">
            <van-col span="7" v-for="(item, index) in menuList" :key="index" class="menu_grid_item">
               <div class="menu_item_inner" @click="menuClick(item.name)">
                  <img class="menu_item_icon" :src="item.activity_icon" alt="" />
               </div>
               <div class="menu_item_text">{{ t(`activityName.${item.name}`) }}</div>
            </van-col>
         </van-row>
      </div>

      <div class="caller">
         <img src="@/assets/themetwo/f3.png" alt="" @click="openContactPopup">

         <div class="downloadBtn" v-if="showPWAButton">
            <img src="@/assets/themetwo/downloadApp.png" alt="">
            <div @click="downloadApp">{{ $t('pwaInstructions.btnText') }}</div>
         </div>
      </div>


   </van-popup>
   <CollectPopup ref="collectPopupRef" />
   <CollectTimeDropPopup ref="collectTimeDropPopupRef" />
   <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
   <AgentPopup ref="agentRef" />
   <CarteiraView ref="walletPopupRef" />
   <PwaAntiBlockingPopup ref="pwaPopupRef" />
   <PwaStatusPopup ref="pwaPopupStatusRef" />
</template>

<script setup lang="ts">
import { computed, defineExpose, inject, ref, defineProps, onMounted, defineEmits } from 'vue'
import PrimaryButton from '../common/primaryButton.vue'
import { useRouter } from 'vue-router'
import CollectPopup from '@/view/collect/collectPopup.vue'
import CollectTimeDropPopup from '@/view/collect/collectTimeDropPopup.vue'
import AgentPopup from '@/view/agent/agentPopup.vue'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { goToShare, handleMenuClick, SHARE_LIST, SideMenuListItem, useButtonClick } from '@/view/components/supportFunction'
import { copyID } from '@/view/profile/supportScript'
import CarteiraView from '@/view/carteiraView/carteiraView.vue'
import { Capacitor } from '@capacitor/core'
const activityStore = useActivityStore()
const userStore = useUserStore()
const userAccount = computed(() => userStore.loginAccount)
const uId = computed(() => userStore.id)
const { t } = useI18n();
const show = ref(false)
const walletPopupRef = ref()
const { buttonClick } = useButtonClick(walletPopupRef, show)
const router = useRouter()
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)
const showPWAButton = ref(false)
const shareList = ref(SHARE_LIST)

const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const statusRef = ref()
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()

const emits = defineEmits(['intallPWA', 'openContactPopup'])
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const contactRef = ref()

const openContactPopup = () => {
   show.value = false
   emits('openContactPopup')
}
const openSidebar = () => {
   show.value = true
   pwaPopBtnDisplayChecking()
}

const closeSidebar = () => {
   playClickSound()
   show.value = false
}
const openRegisterPopup = (type: number) => {
   openRegisterLoginPopup?.(type)
}
const props = defineProps<{
   listGameData: Array<{
      name: string,
      customIcon: string,
      id: number | string,
   }>
}>()

const onCopyID = (id: any) => copyID(statusRef, id)

const menuClick = (name: any) => {
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}

const downloadApp = () => {
   // emits('intallPWA')
   handleMenuClick('pwa_reward', router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}

const pwaPopBtnDisplayChecking = () => {
   const isNativeApp = Capacitor.isNativePlatform();
   const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
   if (isStandalone || isNativeApp) {
      showPWAButton.value = false;
   } else {
      showPWAButton.value = true
   }
}
defineExpose({
   openSidebar,
   closeSidebar
})

</script>
<style scoped>
.navBar {
   width: 100%;
   z-index: 2000;
   padding-top: 5px;
   background: #3b372b;
   background-color: #221b24;
}

.navBar_menu {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 8px;
}

.navBar_menu img {
   width: 50px;
}

.navBar_logo {
   display: flex;
   align-items: center;
   justify-content: right;
   padding: 5px 0;
}

.navBar_logo img {
   width: 120px;
}

.navNotice img {
   width: 100%;
}

.van-popup {
   background: #3b372b;
   background-color: #221b24;
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
   padding: 0 15px;
}

.van-popup::-webkit-scrollbar {
   display: none;
}

.infoContainer {
   background: #312734;
   border-radius: 10px;
   margin-top: 10px;
   padding: 10px;
}

.button_group {
   display: flex;
   justify-content: center;
   padding: 5px 0 0;
}

.btn_grid {
   padding: 4px;
}

.van-overlay {
   backdrop-filter: blur(5px);
   -webkit-backdrop-filter: blur(5px);
   z-index: 10001 !important;
}

.menu_list {
   padding: 12px 0;
   position: relative;
}

.menu_row {
   padding: 0 5%;
}

.menu_icon {
   width: 100%;
   margin-bottom: 10px;
}

.menu_grid_item {
   color: rgba(255, 255, 255, 0.45);
   box-sizing: border-box;
   border-radius: 10px;
}

.menu_item_inner {
   background-image: linear-gradient(180deg, rgb(129 54 94 / 12%) 0%, rgb(249 65 201 / 36%) 100%);
   border: 1.5px solid #daa6cf66;
   margin: 5px;
   border-radius: 10px;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 5px;
}

.menu_item_icon {
   width: 70%;
   object-fit: contain;
   padding: 10px;
   border-radius: 5px;
}

.menu_item_text {
   font-size: 12px;
   text-align: center;
   color: #ffffff;
}

.game_list {
   background: rgba(61, 46, 34, 0.75);
   color: rgba(255, 255, 255, 0.45);
   border-radius: 10px;
   margin: 5px 20px;
   padding: 7px;
   position: relative;
   cursor: pointer;
}

.caller img {
   width: 100%;
}

.downloadBtn {
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: center;
   border-radius: 15px;
   color: #fff;
   background: linear-gradient(90deg, rgb(225, 81, 164), rgb(230, 111, 200));
   padding: 10px;
   font-size: 15px;
   margin-top: 15px;
}

.downloadBtn img {
   width: 25px;
   margin-right: 10px;
}

.game_img_col {
   display: flex;
   justify-content: center;
   align-items: center;
}

.game_icon {
   width: auto;
   height: 35px;
   border-radius: 5px;
   object-fit: cover;
}

.game_name_col {
   display: flex;
   align-items: center;
   justify-content: center;
   text-align: center;
   height: 100%;
   flex-direction: column;
}


.game_name {
   font-size: 15px;
   color: #fff;
   margin-left: 10px;
}


.menu_img img {
   width: 25px;
}

.menu_text {
   color: #FFFFFF;
   font-size: 15px;
   font-weight: 400;
}

.menus {
   padding: 7.5px 0;
   position: relative;
}

.menu_icon_img {
   position: absolute;
   bottom: 0;
   right: 0;
   width: 82px;
   height: auto;
}

.share_content {
   border: 1px solid rgba(255, 255, 255, 0.3);
   border-radius: 10px;
   margin: 25px;
   padding: 5px 10px;
   display: flex;
   justify-content: center;
}

.share_item {
   border-radius: 30px;
   background: #7d7d7d12;
   width: 36px;
   height: 36px;
   margin: 5px;
}

.share_item img {
   width: 40px;
}

.user_info {
   color: rgba(255, 255, 255, 0.45);
}

.btn_col {
   padding: 2.5px;
   display: flex;
   justify-content: center;
   align-items: center;
}

.loginButton {
   color: #fff;
   background: #ff69b4;
   border-radius: 10px;
   font-size: 16px;
   font-weight: 400;
   padding: 10px;
   display: flex;
   justify-content: center;
   width: 90px;
}

.registerButton {
   border-radius: 10px;
   color: #3b1d33;
   background: #ffd60c;
   font-size: 16px;
   font-weight: 400;
   padding: 10px;
   display: flex;
   justify-content: center;
   width: 90px;
}

.user_avatar img {
   width: 100%;
   border-radius: 10px;
   /* border: 1px solid rgba(184, 204, 203, 1); */
}

.user_account {
   color: #fff;
   font-size: 4.2vw;
   padding-top: 5px;
   padding-left: 5px;
}

.user_ID {
   color: #fff;
   padding-top: 5px;
   padding-left: 5px;
   display: flex;
   align-items: end;
   font-size: 4.2vw;
}

.user_ID img {
   width: 20px;
   padding-left: 5px;
}

@media (min-width: 450px) {
   .user_avatar img {
      width: 45px;
   }

   .user_ID {
      font-size: 14px;
   }

   .user_account {
      font-size: 15px;
   }

   .van-popup {
      width: 70% !important;
   }
}

.btn_grid .btn_text {
   font-size: 1px !important;
}
</style>